import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.spacings.abs8}px;
  padding-right: ${({ theme }) => theme.spacings.abs8}px;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.spacings.abs8}px;
  padding-right: ${({ theme }) => theme.spacings.abs8}px;
`;

export const DetailsHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacings.abs48}px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;

export const IconCircle = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey(3)};
  border-radius: ${({ theme }) => theme.spacings.abs40}px;
  display: flex;
  height: ${({ theme }) => theme.spacings.abs32}px;
  justify-content: center;
  width: ${({ theme }) => theme.spacings.abs32}px;
`;

export const CloseButton = styled(IconCircle)`
  :hover {
    background-color: ${({ theme }) => theme.colors.grey(5)};
    cursor: pointer;
  }
`;

export const Properties = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const Property = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
`;

export const PropertyLabel = styled(Text).attrs({ variant: 'light' })``;

export const PropertyValue = styled(Text).attrs({ variant: 'primary' })`
  text-align: right;
`;

export const Title = styled(Heading)`
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;

export const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacings.abs8}px
    ${({ theme }) => theme.spacings.abs8}px;
`;
